/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  position: relative;
  text-align: left;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  font-size: calc(14rem /14);
  display: inline-block;
}
:host .menu-button {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
  width: inherit;
  height: inherit;
}

.menu-button:hover {
  cursor: pointer;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

.menu {
  position: absolute;
  white-space: nowrap;
  background: #FFFFFF;
  background: var(--davinci-color-background-08dp, #FFFFFF);
  box-shadow: 0 0 calc(3rem /14) rgba(0, 0, 0, 0.3);
  z-index: 8;
  top: calc(40rem /14);
}
.menu .inner-container {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
  background: #FFFFFF;
  background: var(--davinci-color-background-08dp, #FFFFFF);
}
.menu .inner-container:before {
  background: #FFFFFF;
  background: var(--davinci-color-background-08dp, #FFFFFF);
  content: "";
  height: calc(12rem /14);
  position: absolute;
  right: calc(11rem /14);
  top: calc(-5rem /14);
  transform: rotate(45deg);
  width: calc(12rem /14);
  box-shadow: 0 0 calc(3rem /14) rgba(0, 0, 0, 0.3);
  z-index: -1;
}

:host(:not([left])) .menu {
  right: calc(-5rem /14);
}

:host([left]) .menu {
  left: calc(-5rem /14);
}
:host([left]) .menu .inner-container:before {
  left: calc(11rem /14);
}

:host([external-control]) .menu {
  top: 0;
}

.click-catcher {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 8;
}
.click-catcher.active {
  display: block;
}

:host([hidden]) {
  display: none;
}`;
export { style };
